import { gql } from 'apollo-boost';

export const create = gql`
  mutation create(
    $shipmentCancellationReason: ShipmentCancellationReasonCreateInput!
  ) {
    orgRef_ShipmentCancellationReason {
      create(shipmentCancellationReason: $shipmentCancellationReason) {
        id
        externalId
        name
        description
        active
        changedUtc
        rowVersion
      }
    }
  }
`;

export const update = gql`
  mutation update(
    $shipmentCancellationReason: ShipmentCancellationReasonUpdateInput!
  ) {
    orgRef_ShipmentCancellationReason {
      update(shipmentCancellationReason: $shipmentCancellationReason) {
        id
        externalId
        name
        description
        active
        changedUtc
        rowVersion
      }
    }
  }
`;

export const deleteItems = gql`
  mutation delete($shipmentCancellationReasonId: Int!) {
    orgRef_ShipmentCancellationReason {
      delete(shipmentCancellationReasonId: $shipmentCancellationReasonId)
    }
  }
`;
